let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = Promise.all([load("f8xBv"), load("hhss7"), load("9lDKI")]).then(() => parcelRequire('68LQc'));